import { MobileWalletDrawer, WalletDropdown } from "@solomon-apps/shared";
import type { WalletMenuProps } from "@solomon-apps/shared/src/components/WalletMenu/types";
import type React from "react";

import { useLiveUsdvMigration } from "@/hooks/usdv-migration/useLiveUsdvMigration";

export interface UsdvMigrationWalletMenuProps {
    renderAccountContent?: WalletMenuProps["renderAccountContent"];
    isWalletDropdownOpen: boolean;
    isWalletDrawerOpen: boolean;
    onCloseDropdown: () => void;
    onCloseDrawer: () => void;
    anchorEl: HTMLElement | null;
    onBeforeDisconnect: () => boolean | Promise<boolean>;
}

/** Account-menu view. Migration orchestration lives in its dedicated hook. */
export function UsdvMigrationWalletMenu(
    props: UsdvMigrationWalletMenuProps
): React.ReactElement {
    const { migrationCard } = useLiveUsdvMigration(
        props.isWalletDropdownOpen || props.isWalletDrawerOpen
    );

    return <WalletMenuShell {...props} migrationCard={migrationCard} />;
}

interface WalletMenuShellProps extends UsdvMigrationWalletMenuProps {
    migrationCard: ReturnType<typeof useLiveUsdvMigration>["migrationCard"];
}

function WalletMenuShell({
    isWalletDropdownOpen,
    isWalletDrawerOpen,
    onCloseDropdown,
    onCloseDrawer,
    anchorEl,
    onBeforeDisconnect,
    migrationCard,
    renderAccountContent
}: WalletMenuShellProps): React.ReactElement {
    return (
        <>
            <WalletDropdown
                isOpen={isWalletDropdownOpen}
                onClose={onCloseDropdown}
                anchorEl={anchorEl}
                renderAccountContent={renderAccountContent}
                onBeforeDisconnect={onBeforeDisconnect}
                usdvMigration={migrationCard}
            />
            <MobileWalletDrawer
                isOpen={isWalletDrawerOpen}
                onClose={onCloseDrawer}
                renderAccountContent={renderAccountContent}
                onBeforeDisconnect={onBeforeDisconnect}
                usdvMigration={migrationCard}
            />
        </>
    );
}
